import * as React from "react";
const ChevronUp = props => <symbol viewBox="0 0 24 24" {...props}>
    <path d="M18.53 14.47l-6-6c-.139-.14-.333-.22-.53-.22s-.391.08-.53.22l-6 6a.75.75 0 001.06 1.06L12 10.06l5.47 5.47a.75.75 0 001.06-1.06z" />
  </symbol>;
export default ChevronUp;